<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button (click)="toggleSidebar()" aria-label="Close" class="close" data-dismiss="modal" type="button">
                    ×
                </button>

                <div class="modal-header">
                    <h5 *ngIf="!data || !data['id']" class="modal-title">Add Article</h5>
                    <h5 *ngIf="data && data['id']" class="modal-title">Update Article</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form [formGroup]="addArticlesForm" class="form mt-2 shadow-none" novalidate>
                        <div class="container">
                            <div class="row pb-2">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="author_id">Author</label>
                                        <select class="form-control" formControlName="author_id" id="author_id"
                                                type="text">
                                            <option value="">Select Author</option>
                                            <option *ngFor="let author of authorList" [value]="author?.id">
                                                {{author?.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="heading">Heading</label>
                                        <input class="form-control" formControlName="heading" id="heading" type="text">
                                        <small *ngIf="submitted && addArticlesForm.get('heading').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="short_description">Short Description</label>
                                        <textarea class="form-control resize-none" formControlName="short_description"
                                                  id="short_description"
                                                  type="text"></textarea>
                                        <small
                                                *ngIf="submitted && addArticlesForm.get('short_description').hasError('required')"
                                                class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <button (click)="toggleSidebar()" aria-label="Close" class="btn btn-danger"
                                            data-dismiss="modal"
                                            rippleEffect type="button">
                                        Cancel
                                    </button>
                                    <button (click)="submit()" *ngIf="!data || !data['id']"
                                            class="btn btn-primary ml-1 pull-right"
                                            rippleEffect type="submit">Submit
                                    </button>
                                    <button (click)="update()" *ngIf="data && data['id']"
                                            class="btn btn-primary ml-1 pull-right"
                                            rippleEffect type="submit">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
</div>
